import { MaterialThemeProvider } from 'dg-web-shared/common/hooks/MaterialThemeProvider.tsx';
import { defaultOperatorMuiTheme } from 'operator-shared/theme/DefaultOperatorMuiTheme.ts';
import { ReactNode } from 'react';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

export function OperatorThemeProvider({ children }: { children: ReactNode }) {
    const { language } = useLanguage();
    return (
        <MaterialThemeProvider
            theme={defaultOperatorMuiTheme}
            language={language}
        >
            {children}
        </MaterialThemeProvider>
    );
}
